export default __webpack_public_path__ + "static/media/hero-image2.00fe2160.jpg";